import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="23"
      fill="none"
      viewBox="0 0 24 23"
    >
      <path
        fill="#27BD83"
        d="M9.5 8.5L12 0l3 8.5h9L17 14l2.5 8.5L12 17l-7 5.5 2.5-9-7.5-5h9.5z"
      ></path>
    </svg>
  );
}

export default Icon;
